import get from 'lodash/get';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useFormContext } from 'react-hook-form';
import { Chip } from 'shared/mui/Chips';
import { useAnchor } from 'shared/mui/DatePicker/hooks/useAnchor';
import { useFilterContext } from 'shared/mui/Filter/context/filterContext';
import { PopoverChip } from 'shared/mui/Filter/FilterChipsToolbar/FilterChips/components/PopoverChip/PopoverChip';

import { RowStyled } from './FilterFromToChip.styled';

export type FilterFromToChipProps = {
  label: string;
  fromName: string;
  toName: string;
  fromSlot: React.ReactNode;
  toSlot: React.ReactNode;
};

export const FilterFromToChip: React.FC<FilterFromToChipProps> = ({
  fromSlot,
  toSlot,
  fromName,
  label,
  toName,
}) => {
  const translate = useTypedTranslate();
  const { handleClose, handleClick, anchorEl } = useAnchor<HTMLDivElement>();

  const { appliedFilters, setAppliedFilter } = useFilterContext();
  const { reset, clearErrors, getValues, setValue } = useFormContext();

  const valueFrom = get(appliedFilters, fromName);
  const valueTo = get(appliedFilters, toName);

  if (!valueFrom && !valueTo) {
    return <></>;
  }

  function onApply() {
    handleClose();
    setAppliedFilter(fromName, getValues(fromName));
    setAppliedFilter(toName, getValues(toName));
  }

  function onReset() {
    setAppliedFilter(fromName, get(appliedFilters, fromName));
    setAppliedFilter(toName, get(appliedFilters, toName));
    setValue(fromName, get(appliedFilters, fromName));
    setValue(toName, get(appliedFilters, toName));
    clearErrors(fromName);
    clearErrors(toName);
  }

  const fromString = valueFrom ? `${translate('app.common.from')} ${valueFrom}` : '';
  const toString = valueTo ? ` ${translate('app.common.to')} ${valueTo}` : '';

  const open = Boolean(anchorEl);

  return (
    <>
      <PopoverChip
        anchorEl={anchorEl}
        onApply={onApply}
        onClose={handleClose}
        onReset={onReset}
        open={open}
      >
        <RowStyled>
          {fromSlot} {toSlot}
        </RowStyled>
      </PopoverChip>
      <Chip
        label={`${label}: ${fromString}${toString}`}
        onClick={handleClick}
        onDelete={() => {
          reset({ [fromName]: null, [toName]: null });
          setAppliedFilter(fromName, undefined);
          setAppliedFilter(toName, undefined);
        }}
        size="medium"
      />
    </>
  );
};
